import React, { createContext, useEffect, useState } from 'react';
import clienteAxios from '../../config/axios';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
	const [user, setUser] = useState({ username: null, email: null });
	const [authStatus, setAuthStatus] = useState(false);
	const [isVerifying, setIsVerifying] = useState(true); // Estado para saber si se está verificando el token
	const [isAdmin, setIsAdmin] = useState(false);
	const [data, setData] = useState({
		email: '',
		password: '',
	});

	useEffect(() => {
		if (user && user.isAdmin) setIsAdmin(user.isAdmin);
		else setIsAdmin(false);
	}, [user]);

	const handleChange = (event) => {
		event.preventDefault();
		setData({
			...data,
			[event.target.name]: event.target.value,
		});
	};

	const registerUser = async (dataForm) => {
		try {
			const res = await clienteAxios.post('/usuarios/crear', dataForm);
			localStorage.setItem('token', res.data.token);
			setAuthStatus(true);
		} catch (error) {
			console.error(error);
		}
	};

	const verifyingToken = async () => {
		const token = localStorage.getItem('token');

		if (token) {
			clienteAxios.defaults.headers.common['x-auth-token'] = token;
		} else {
			delete clienteAxios.defaults.headers.common['x-auth-token'];
		}

		try {
			if (token) {
				const respuesta = await clienteAxios.get('/usuarios/verificar');
				setUser(respuesta.data.usuario);
				setAuthStatus(true);
			} else {
				setAuthStatus(false);
			}
		} catch (error) {
			console.error('Error Verificando token', error);
			setAuthStatus(false);
			localStorage.removeItem('token');
			delete clienteAxios.defaults.headers.common['x-auth-token'];
		} finally {
			setIsVerifying(false);
		}
	};

	const loginUser = async (dataForm) => {
		try {
			const respuesta = await clienteAxios.post('/usuarios/login', dataForm);
			localStorage.setItem('token', respuesta.data.token);
			setAuthStatus(true);
			await verifyingToken();
			alert('Usuario Logeado');
		} catch (error) {
			console.error(error);
		}
	};

	const logout = () => {
		localStorage.removeItem('token');
		setUser(null);
		setAuthStatus(false);
	};

	// Verificar token al montar el provider
	useEffect(() => {
		verifyingToken();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const contextData = {
		user,
		authStatus,
		isVerifying,
		registerUser,
		loginUser,
		handleChange,
		verifyingToken,
		logout,
		data,
		isAdmin,
	};
	// console.log('UserContext :', contextData)
	return (
		<UserContext.Provider value={contextData}>{children}</UserContext.Provider>
	);
};
